module.exports = "<app-side-nav></app-side-nav>\r\n"